import React from 'react';
import { XIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 px-4 bg-white border-t border-gray-100" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-133">
          <p data-id="element-134">Sé exactamente cómo te sentís.</p>

          <p data-id="element-135">Son las 7 de la mañana y ya estás agotada.</p>

          <p data-id="element-136">
            El nene no quiere levantarse. La nena llora porque el vaso no es el
            rosa. Y vos... ya empezaste el día sintiéndote como si hubieras
            perdido una batalla que ni siquiera empezó.
          </p>

          <p data-id="element-137">Intentás hablar tranquila. Respirás. Contás hasta tres.</p>

          <p data-id="element-138">
            Y de repente...{' '}
            <strong className="text-red-600 text-2xl" data-id="element-139">explotás.</strong>
          </p>

          <p data-id="element-140">
            Y después viene lo peor:{' '}
            <strong className="text-gray-900" data-id="element-141">la culpa.</strong>
          </p>

          <div className="bg-slate-50 p-6 rounded-xl border-l-4 border-slate-300 my-8 space-y-4 italic text-gray-600" data-id="element-142">
            <p data-id="element-143">"No tendría que haberle gritado así."</p>
            <p data-id="element-144">"¿Por qué no puedo controlarme?"</p>
            <p data-id="element-145">"¿Qué clase de mamá soy?"</p>
          </div>

          <p data-id="element-146">Esa voz en tu cabeza que no para.</p>

          <div className="my-16 text-center" data-id="element-147">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-148">
              ¿Y si te dijera que el problema no sos vos?
            </h2>
            <p className="text-xl" data-id="element-149">
              El problema es que nadie te enseñó una herramienta real para ese
              momento. Una que funcione cuando estás al límite, sin dormir, con
              mil cosas en la cabeza y dos nenes tironeándote del brazo.
            </p>
            <p className="text-2xl font-bold text-green-600 mt-8 bg-green-50 inline-block px-6 py-3 rounded-lg" data-id="element-150">
              Eso es exactamente lo que el MÉTODO CALMA® te da.
            </p>
          </div>

          <div className="bg-red-50 rounded-2xl p-8 md:p-10 my-12 border border-red-100" data-id="element-151">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-152">
              El problema no es que seas mala mamá. Es que nadie te dio las
              herramientas correctas.
            </h3>

            <ul className="space-y-4 mb-8" data-id="element-153">
              <li className="flex items-start gap-3" data-id="element-154">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-155" />
                <span data-id="element-156">
                  Probaste respirar profundo. <strong data-id="element-157">No alcanzó.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-158">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-159" />
                <span data-id="element-160">
                  Probaste ignorar la rabieta. <strong data-id="element-161">Empeoró.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-162">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-163" />
                <span data-id="element-164">
                  Probaste el tiempo fuera. <strong data-id="element-165">Lloró más fuerte.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-166">
                <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-167" />
                <span data-id="element-168">
                  Probaste hablar tranquila.{' '}
                  <strong data-id="element-169">Te salió gritando igual.</strong>
                </span>
              </li>
            </ul>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100" data-id="element-170">
              <p className="font-bold text-xl text-gray-900 mb-4 text-center" data-id="element-171">
                Y lo peor no es el grito. Lo peor es lo que sentís después.
              </p>
              <p className="text-gray-700 text-center" data-id="element-172">
                Esa mezcla de culpa, agotamiento y miedo de estar fallando. Esa
                sensación de que tus hijos merecen una versión de vos que no
                podés sostener sola.
              </p>
              <p className="text-center text-xl mt-6" data-id="element-173">
                No es falta de amor.{' '}
                <strong className="text-red-600" data-id="element-174">
                  Es falta de un sistema.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}